const mediaCache = new Map();
export const storeLocalPreviewUrls = (id, files) => {
    const urls = files.map((file) => URL.createObjectURL(file));
    mediaCache.set(id, urls);
};
export const getLocalPreviewUrls = (id) => mediaCache.get(id) ?? [];
export const clearLocalPreviewUrls = (id) => {
    const urls = mediaCache.get(id) ?? [];
    urls.forEach((url) => URL.revokeObjectURL(url));
    mediaCache.delete(id);
};
